import __variableDynamicImportRuntimeHelper from "./_virtual/dynamic-import-helper.js";
import { jsx } from "react/jsx-runtime";
import { Skeleton, Box } from "@chakra-ui/react";
import { useMemo, useState, useLayoutEffect, useEffect } from "react";
import { UNKNOWN_COUNTRY_CODE, isCountryFlagCode } from "./countries.js";
const FLAG_STYLES = {
  l: { w: "42px", h: "32px", radius: "4px" },
  m: { w: "32px", h: "24px", radius: "4px" },
  s: { w: "26px", h: "20px", radius: "2px" },
  xs: { w: "20px", h: "15px", radius: "2px" }
};
const MISSING_FLAGS = ["ana", "ta", "world"];
const MAPPED_FLAGS = {
  ea: "es"
};
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function Flag({ code, size, title, greyscale = false, rounded = false }) {
  const { w, h, radius } = FLAG_STYLES[size];
  const mappedCode = useMemo(
    () => isCountryFlagCode(code) ? MAPPED_FLAGS[code] ?? code : UNKNOWN_COUNTRY_CODE,
    [code]
  );
  const [iconUri, setIconUri] = useState(countryFlagUri(mappedCode));
  useIsomorphicLayoutEffect(() => {
    if (MISSING_FLAGS.includes(mappedCode)) {
      const importIcon = async () => await __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/ana.svg": () => import("./assets/ana.svg.js"), "./assets/ta.svg": () => import("./assets/ta.svg.js"), "./assets/world.svg": () => import("./assets/world.svg.js") }), `./assets/${mappedCode}.svg`, 3);
      void importIcon().then((icon) => {
        setIconUri(icon.default);
      });
    } else {
      setIconUri(countryFlagUri(mappedCode));
    }
  }, [mappedCode]);
  return /* @__PURE__ */ jsx(Skeleton, { isLoaded: Boolean(iconUri), children: /* @__PURE__ */ jsx(
    Box,
    {
      filter: greyscale ? "grayscale(100%)" : void 0,
      borderRadius: rounded ? "full" : radius,
      overflow: "hidden",
      width: rounded ? h : w,
      height: h,
      boxShadow: "inset 0 0 0 1px rgba(37, 48, 60, 0.1)",
      background: `url("${iconUri}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      "data-flag": title ?? code
    }
  ) });
}
function countryFlagUri(code) {
  return `https://cdn.jsdelivr.net/gh/lipis/flag-icons@main/flags/4x3/${code}.svg`;
}
export {
  Flag as default
};
//# sourceMappingURL=Flag.js.map
